import { BidAbstract } from './bid-abstract'
import { CompetitorBid } from './competitor-bid'

export class Bid {
    id!: string
    wasBid!: boolean
    heavyBidNum!: number
    estimatorHrRef!: number
    ownerId!: string
    job!: string
    countyId!: string
    bidDate!: Date
    laborPercentCostFactor!: number
    averageMarkUpPercent!: number
    markUp!: number
    overheadAddOn!: number
    equipOpExp!: number
    coEquip!: number
    bidTypeId!: string
    high!: number
    low!: number
    vanCon!: number
    rank!: number
    won?: number
    numBidders!: number
    lowBidWinnerId!: string
    secondPlaceCompetitorId!: string
    secondPlaceBid!: number
    thirdPlaceCompetitorId!: string
    thirdPlaceBid!: number
    lowEstimate?: number
    highEstimate?: number

    competitorBids?: CompetitorBid[]
    bidAbstracts?: BidAbstract[]

    lostBy?: number
    percentOver?: number

    protected $setProperties(source: any): void {
        this.lostBy = source.vanCon && source.low ? source.vanCon - source.low : undefined
        this.percentOver = this.lostBy && source.low ? this.lostBy / source.low : undefined
    }
}
